<template>
  <div>
    <div>
    <valid-van-field
      v-model="col"
      :label="label"
      center
      :placeholder="placeholder"
      :rules="reg"
      maxlength="6"
      type="number"
    >
      <button
        type="button"
        slot="button"
        id="buttonStyle"
        :disabled="disabled"
        @click="sendcode"
      >
        {{ messageButton }}
      </button>
    </valid-van-field>
  </div>
  <div class="line">
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Field, Toast } from 'vant';
import ValidHoc from '@/components/valid';
import service from '@/request/api';
// 导入api接口
const ValidVanField = ValidHoc(Field);

export default {
  name: 'MessageCode',
  components: {
    ValidVanField,
  },
  data() {
    return {
      disabled: false,
      messageButton: '获取验证码',
      time: 0,
      col: '',
    };
  },
  props: [
    'label',
    'placeholder',
    'reg',
    'IsInterface',
    'value',
    'params',
  ],
  watch: {
    col: {
      // eslint-disable-next-line no-unused-vars
      handler(value, oldVal) {
        if (oldVal === undefined) {
          this.col = this.value;
        }
        this.$emit('input', value);
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal) {
        this.col = newVal;
        this.$emit('input', newVal);
      },
      immediate: true,
    },
  },
  methods: {
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        // eslint-disable-next-line no-plusplus
        this.time--;
        this.messageButton = `${this.time}s后获取`;
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageButton = '获取验证码';
        this.disabled = false;
      }
    },
    // eslint-disable-next-line consistent-return
    sendcode() {
      const reg = /^1[0-9]{10}$/;
      if (!this.params.phone) {
        return Toast({
          message: '手机号不能为空',
          forbidClick: true, // 背景不可点击
        });
      } if (!reg.test(this.params.phone)) {
        return Toast({
          message: '请输入正确的手机号',
          forbidClick: true, // 背景不可点击
        });
      }
      this.disabled = true;

      // 如果后台返回了发送验证码url则用后台的，否则走原流程
      this.params && !this.params.smsUrl ? this.params.smsUrl = '/backloansuper/loan/supermarket/smsWithLogin/v1.0' : this.params.smsUrl.indexOf('backloansuper') > -1 ? '' :  this.params.smsUrl = '/backloansuper' + this.params.smsUrl;
      service.CommonForms.getDynamicMessageCode(this.params).then((res) => {
        if (!res.success) {
          Toast({
            message: res.returnMessage,
            forbidClick: true, // 背景不可点击
          });
          this.disabled = false;
        } else {
          this.time = 60;
          this.timer();
        }
      }).catch((e) => {
        Toast('验证码获取失败');
        this.disabled = false;
      });
    },
  },
};
</script>
<style scoped>
.bgColor {
  background: #f8f8f9;
}
.van-button--small {
  min-width: 60px;
  height: 30px;
  padding: 0 8px;
  color: #ff6538;
  font-size: 12px;
  line-height: 28px;
  background-color: #fff;
}

.buttonDe {
  margin: 0;
  color: #ccc;
  font-size: 14px;
  outline: none;
}
#buttonStyle {
  margin: 0;
  padding: 0;
  color: #ff6538;
  font-size: 14px;
  background: #fff;
  border: 1px solid transparent;
  outline: none;
  position: absolute;
  top: -2px;
  right: 0;
}
.MessageCode {
  position: relative;
}
.line{
  position: relative;
  height: 1px;
}
.line::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
</style>
